import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import { useSelector } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import { useLabels, usePrefs, useRequestData } from 'wsm-common-data';
import { MyCarsCtas } from 'wsm-mycars-ctas';
import { useFetchVehicleData, useVehicleStorage } from '../hooks';
import '../global-sass/main.scss';

function WidgetContainer({ vehicleId, siteId, accountId }) {
	const labels = useLabels();
	const { saveLabel } = usePrefs();
	const { deviceType } = useRequestData();
	const isDesktop = deviceType !== 'MOBILE';
	const enableMyCars =
		isBrowser && window.DDC?.siteProperties?.enableMyCars === 'true';

	useVehicleStorage({ vehicleId });

	const { response: wisResponse } = useFetchVehicleData({
		vehicleId,
		siteId,
		accountId,
		enableMyCars
	});

	const ctasLabels = useMemo(
		() => [
			{
				id: 'save',
				label: labels.get(saveLabel)
			}
		],
		[labels, saveLabel]
	);

	const containerClasses = setClassNames([
		'd-flex',
		'gap-x-2',
		'text-muted',
		'ddc-font-size-small',
		isDesktop ? 'justify-content-end' : 'justify-content-around'
	]);

	if (!vehicleId || !enableMyCars) {
		return null;
	}

	const isInLine = true;

	const mycarsCtasProps = {
		accountId,
		siteId,
		bodyStyle: wisResponse?.bodyStyle,
		image: wisResponse?.image,
		isInLine,
		labels: ctasLabels,
		make: wisResponse?.make,
		model: wisResponse?.model,
		price: wisResponse?.price,
		stockNumber: wisResponse?.stockNumber,
		title: wisResponse?.title,
		trim: wisResponse?.trim,
		type: wisResponse?.type,
		uuid: vehicleId,
		vin: wisResponse?.vin,
		year: wisResponse?.year
	};

	return (
		<div className={containerClasses}>
			<MyCarsCtas {...mycarsCtasProps} />
		</div>
	);
}

WidgetContainer.propTypes = {
	vehicleId: PropTypes.string.isRequired,
	siteId: PropTypes.string.isRequired,
	accountId: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
	vehicleId: state.storedRequestData.vehicleId,
	accountId: state.storedRequestData.accountId,
	siteId: state.storedRequestData.siteId
});

const Widget = () => {
	const { vehicleId, accountId, siteId } = useSelector(mapStateToProps);
	return (
		<WidgetContainer
			vehicleId={vehicleId}
			accountId={accountId}
			siteId={siteId}
		/>
	);
};

export default Widget;
